import { render, staticRenderFns } from "./PreparationNews.vue?vue&type=template&id=206e171f&"
import script from "./PreparationNews.vue?vue&type=script&lang=js&"
export * from "./PreparationNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports